import { AttributeDetailModel } from '@leverege/ui-attributes'

const TYPE = 'ps.detail.segmentImageDetail'

function create( attrName, objectType ) {
  return {
    ...AttributeDetailModel.create( attrName, objectType ),
    type : TYPE
  }
}

export default {
  create,
  TYPE,
  getName( model ) {
    return 'Segment Images'
  }
}
